import { CreatorContactDetails } from "@shared/ui";
import { IInfluencerContact } from "@shared/lib/types/briefInfluencerV2";
import { Contact } from "lucide-react";
import styles from "./CreatorContactSection.module.scss";

interface CreatorContactSectionProps {
  contact?: IInfluencerContact;
  isContactAdded: boolean;
}

export function CreatorContactSection({
  contact,
  isContactAdded,
}: CreatorContactSectionProps) {
  return (
    <section className={styles.contactSection}>
      <div className={styles.header}>
        <Contact size={14} className={styles.headerIcon} />
        <div>
          <h4 className={styles.title}>Contact Details</h4>
          <p className={styles.subtitle}>
            Primary phone, email, and representative for this creator
          </p>
        </div>
      </div>
      <div className={styles.content}>
        <CreatorContactDetails
          contact={contact}
          isContactAdded={isContactAdded}
        />
      </div>
    </section>
  );
}
